import * as React from "react";
// import Checkbox from '../Checkbox'
import { Grid, Row, Col, ButtonToolbar, Button, ButtonGroup, Table, Alert } from "react-bootstrap";
import "./identity.css";
import { IdentityDto, INewIdentityDto } from "src/services";
import { IRootState } from "src/reducers";
import { loadIdentities, deleteIdentity, createIdentity } from "src/actions";
import { connect } from "react-redux";
import Checkbox from "../Checkbox";
import LoadingOverlay from "../loading-overlay";
import Sidebar from "../sidebar";
import { ILocalizedError } from "src/i18n/error-localization";

interface IIdentityProps {
  error: ILocalizedError;
  identities: IdentityDto[];
  isLoading: boolean;
  loadIdentities: () => void;
  createIdentity: (identity: INewIdentityDto) => void;
  deleteIdentity: (id: string) => void;
}

interface IIdentityState {
  checkedIds: string[];
  allChecked: boolean;
}

class IdentityList extends React.Component<IIdentityProps, IIdentityState> {
  public state = {
    allChecked: false,
    checkedIds: []
  };

  public componentDidMount() {
    document.body.classList.remove("login-body-theme");
    document.body.classList.add("main-body-theme");

    this.props.loadIdentities();
  }

  public render() {
    return (
      <Grid fluid={true}>
        <LoadingOverlay isLoading={this.props.isLoading} />
        {this.props.error && (
          <Row style={{ paddingTop: "10px" }}>
            <Col md={12}>
              <Alert bsStyle="danger" closeLabel="Close">
                {this.props.error!.defaultMessage}
              </Alert>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={12} className="text-right">
            <ButtonToolbar style={{ margin: "10px 0px" }}>
              <ButtonGroup>
                <Button bsStyle="primary" onClick={this.createSampleIdentity}>
                  Create
                </Button>
              </ButtonGroup>
              <ButtonGroup>
                <Button bsStyle="danger" onClick={this.deleteChosenIdentities}>
                  <span className="glyphicon glyphicon-trash" />
                  &nbsp; Delete
                </Button>
              </ButtonGroup>
            </ButtonToolbar>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="identity-table-scroll-wrapper">
              <Table hover={true} condensed={true}>
                <thead>
                  <tr>
                    <th className="col-checkbox">
                      <Checkbox checked={this.state.allChecked} value="all" onChange={this.toggleAll} />
                    </th>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.identities.map(identity => (
                    <tr key={identity.id}>
                      <td className="col-checkbox">
                        <Checkbox
                          checked={this.isChecked(identity.id!)}
                          value={identity.id!}
                          onChange={this.handleCheckboxChange}
                        />
                      </td>
                      <td>{identity.id}</td>
                      <td>{identity.name}</td>
                      <td>{identity.description}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
        <Sidebar>
          <div className="sidebar-title">No filters for this view</div>
        </Sidebar>
      </Grid>
      // <Grid fluid={true}>
      //     <Row style={{paddingTop: '30px'}}>
      //         <Col md={12} className="text-center">
      //             <h1>Identities <small>(not implemented yet)</small></h1>
      //         </Col>
      //     </Row>
      // </Grid>
    );
  }

  private isChecked = (id: string) => this.state.checkedIds.findIndex(item => item === id) > -1;

  private toggleAll = (val: string, checked: boolean) => {
    this.setState(() => {
      if (checked) {
        return {
          allChecked: true,
          checkedIds: this.props.identities.map(item => item.id!)
        };
      } else {
        return {
          allChecked: false,
          checkedIds: []
        };
      }
    });
  };

  private handleCheckboxChange = (id: string, checked: boolean) => {
    this.setState(prevState => {
      if (checked) {
        return { checkedIds: [id, ...prevState.checkedIds] };
      } else {
        const newIds = prevState.checkedIds.slice();
        return { checkedIds: newIds.filter(item => item !== id) };
      }
    });
  };

  private createSampleIdentity = () => {
    const random = parseInt((100 * Math.random()).toString(), 10);
    const payload = {
      description: `sample ${random}`,
      identityClaims: "",
      identityType: "common",
      name: `sample ${random}`
    };

    this.props.createIdentity(payload);
  };

  private deleteChosenIdentities = () => {
    const idsToRemove = this.state.checkedIds.map(id => id);

    idsToRemove.forEach(id => {
      this.props.deleteIdentity(id);
    });
  };
}

const mapStateToProps = (state: IRootState) => ({
  error: state.identities.error,
  identities: state.identities.entities,
  isLoading: state.identities.isLoading
});

export default connect(
  mapStateToProps,
  { loadIdentities, createIdentity, deleteIdentity }
)(IdentityList);



// WEBPACK FOOTER //
// ./src/components/identity/index.tsx